import { offlineDb } from './offline-db'
import { PRESERVED_META_KEYS } from './device-provision-meta'

/**
 * Soft logout: pulisce sessione e dati operativi; mantiene `offlineData` (rubrica, form cache, utenti login offline)
 * e `initSnapshots` (necessario per re-login offline verso /home).
 * Mantiene anche meta di provisioning (`deviceProvision`).
 */
export async function clearSessionStores() {
  await offlineDb.localIncidents.clear()
  await offlineDb.syncQueue.clear()
  await offlineDb.localSessions.clear()
  const metaRows = await offlineDb.meta.toArray()
  const toDelete = metaRows
    .map((row) => row.key)
    .filter((key) => !PRESERVED_META_KEYS.has(key))
  if (toDelete.length > 0) {
    await offlineDb.meta.bulkDelete(toDelete)
  }
}

/**
 * Hard logout: pulisce tutto incluso snapshot init e store generico IndexedDB.
 */
export async function clearAllOfflineStores() {
  await clearSessionStores()
  await offlineDb.initSnapshots.clear()
  await offlineDb.offlineData.clear()
}

/** @deprecated Usare clearSessionStores */
export { clearSessionStores as clearCurrentSession }
